<template>
    <div class="w-full">
        <ProductDetailTabs />
    </div>
</template>
